import "./Loader.css";
import React from "react";
import Lottie from 'react-lottie-player';
import LottieLoader from 'assets/lottie/FlowMinder_Loading_Wheel.json'

function Loader() {
    return (
        <div className="overlay">
            <Lottie
                loop
                animationData={LottieLoader}
                play
                style={{ width: 120, height: 120 }}
            />
        </div>
    );
}

export default Loader;